import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import UserModal from '../../common/UserModal'

import * as Functions from '../../../helpers/Functions'
import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as usersActions from '../../actions/Users'

class EditUserModal extends Component {
  state = {
    emailInput: '',
    admin: '',
    errorEmail: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, users } = this.props

    if (nextProps.config.editUserModal.show && !config.editUserModal.show) {
      this.setState({
        emailInput: nextProps.users.selected.email,
        admin: nextProps.users.selected.admin,
        errorEmail: '',
        errorMessage: ''
      })
    }

    if (
      !nextProps.users.isUpdating &&
      nextProps.users.errorUpdating === null &&
      users.isUpdating
    ) {
      this.props.hideEditUserModal()
      this.props.showSnackbar(Strings.default.USER_UPDATED)
    } else if (
      !nextProps.users.isUpdating &&
      nextProps.users.errorUpdating !== null &&
      users.isUpdating
    ) {
      if (nextProps.users.errorUpdating === 409) {
        this.setState({ errorEmail: Strings.default.EMAIL_IN_USE })
      } else {
        this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
      }
    }
  }

  updateUser() {
    const { data, user, users } = this.props
    const { emailInput } = this.state

    this.setState({ errorMessage: '' })

    if (emailInput === '' || !Functions.isValidEmail(emailInput)) {
      if (emailInput === '') {
        this.setState({ errorEmail: Strings.default.MANDATORY_FIELD })
      } else {
        this.setState({ errorEmail: Strings.default.NOT_VALID_EMAIL })
      }
    }

    if (emailInput !== '' && Functions.isValidEmail(emailInput)) {
      const postData = {
        email: this.state.emailInput,
        admin: this.state.admin
      }

      this.props.tryUpdateUser(
        user.token,
        data.community.id,
        users.selected.id,
        postData
      )
    }
  }

  render() {
    const { config, users } = this.props
    const { emailInput, admin, errorEmail, errorMessage } = this.state

    return (
      <UserModal
        show={config.editUserModal.show}
        hide={() => this.props.hideEditUserModal()}
        emailInput={emailInput}
        onChangeEmailInput={text =>
          this.setState({ emailInput: text, errorEmail: '', errorMessage: '' })
        }
        errorEmail={errorEmail}
        isAdmin={admin}
        onChangeIsAdmin={checked =>
          this.setState({ admin: checked, errorMessage: '' })
        }
        header={Strings.default.EDIT_USER}
        information={Strings.default.EDIT_USER_INFORMATION}
        onDone={() => this.updateUser()}
        loading={users.isUpdating}
        errorMessage={errorMessage}
        extraInformation={Strings.default.INFO_CHANGE_PASSWORD}
      />
    )
  }
}

function mapStateToProps({ config, data, user, users }) {
  return { config, data, user, users }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...usersActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUserModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditUserModal/index.js